import { useState } from "react";

import { Level } from "@/components/Levels/components/Level";
import { Level3 } from "@/components/Levels/components/Level3";
import { LevelProps } from "@/interfaces/components";

import { SheetModal } from "../index";

export const useLevelModal = () => {
  const [isOpen, setOpen] = useState<boolean>(false);
  const [level, setLevel] = useState<LevelProps | null>(null);

  const openModal = (level: LevelProps) => {
    setOpen(true);
    setLevel(level);
  };

  const closeModal = () => {
    setOpen(false);
  };

  const modal = level ? (
    <SheetModal isOpen={isOpen} closeModal={closeModal} detent="content-height">
      {level.level === 3 ? <Level3 {...level} /> : <Level {...level} />}
    </SheetModal>
  ) : (
    <></>
  );

  return { isOpen, openModal, closeModal, modal };
};
